import React from 'react';

type TClickDirection = 'prev' | 'next';

export interface IArrowButtonProps {
  type: TClickDirection;
  onClick: React.MouseEventHandler<HTMLButtonElement>;
}

export const ArrowButton = ({ type, onClick }: IArrowButtonProps) => (
  <button
    type="button"
    className={`carousel__${type}`}
    aria-hidden="true"
    onClick={onClick}
  >
    <img
      src={`${process.env.NEXT_PUBLIC_ASSETS_PREFIX}/images/arrow.svg`}
      alt="arrow icon"
      width="20"
      height="13"
    />
  </button>
);
